import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tutor from './pages/Tutor';
import Quiz from './pages/Quiz';
import NotFound from './pages/NotFound';

// Protected Route wrapper
export const ProtectedRoute = ({ user, children }) => {
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Public Route wrapper (redirect if already logged in)
export const PublicRoute = ({ user, children }) => {
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

// Main routes configuration
export const AppRoutes = ({ user }) => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route 
        path="/login" 
        element={
          <PublicRoute user={user}>
            <Login />
          </PublicRoute>
        } 
      />

      {/* Protected Routes */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute user={user}>
            <Dashboard />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/tutor" 
        element={
          <ProtectedRoute user={user}>
            <Tutor />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/quiz" 
        element={
          <ProtectedRoute user={user}>
            <Quiz />
          </ProtectedRoute>
        } 
      />

      {/* Redirects */}
      <Route path="/" element={<Navigate to={user ? "/dashboard" : "/login"} replace />} />
      
      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};